window.theme = window.theme || {};

// Icons
theme.icons = {
  left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
  right: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
  close: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
  chevronLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
  chevronRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
  chevronDown: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
  tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>'
};

// Lightbox
theme.fbOpts = { overlayColor: '#fff', padding: 1, margin: 60, overlayOpacity: 0.9 };

theme.Sections = new function(){
  var _ = this;
  
  var sections = [];
  var instances = [];
  
  _.init = function(){
    $(document).on('shopify:section:load', function(e){
      // load a new section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionLoad(target);
      }
    }).on('shopify:section:unload', function(e){
      // unload existing section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionUnload(target);
      }
    });
  }
  
  // register a type of section
  _.register = function(type, section){
    sections.push({ type: type, section: section });
    $('[data-section-type="'+type+'"]').each(function(){
      _.sectionLoad(this);
    });
  }
  
  // load in a section
  _.sectionLoad = function(target){
    var target = target;
    var section = _._sectionForTarget(target);
    if(section !== false) {
      instances.push({
        target: target,
        section: section
      });
      section.onSectionLoad(target);
      $(target).on('shopify:block:select', function(e){
        _._callWith(section, 'onBlockSelect', e.target);
      }).on('shopify:block:deselect', function(e){
        _._callWith(section, 'onBlockDeselect', e.target);
      });
    }
  }
  
  // unload a section
  _.sectionUnload = function(target){
    var instanceIndex = -1;
    for(var i=0; i<instances.length; i++) {
      if(instances[i].target == target) {
        instanceIndex = i;
      }
    }
    if(instanceIndex > -1) {
      $(target).off('shopify:block:select shopify:block:deselect');
      _._callWith(instances[instanceIndex].section, 'onSectionUnload', target);
      instances.splice(instanceIndex);
    }
  }
  
  // helpers
  _._callWith = function(object, method, param) {
    if(typeof object[method] === 'function') {
      object[method](param);
    }
  }
  
  _._themeSectionTargetFromShopifySectionTarget = function(target){
    var $target = $('[data-section-type]:first', target);
    if($target.length > 0) {
      return $target[0];
    } else {
      return false;
    }
  }
  
  _._sectionForTarget = function(target) {
    var type = $(target).attr('data-section-type');
    for(var i=0; i<sections.length; i++) {
      if(sections[i].type == type) {
        return sections[i].section;
      }
    }
    return false;
  }
}

theme.HeaderSection = new function(){
  this.onSectionLoad = function(target){
    /// Mobile nav
    if($('#mobile-header .nav', target).length == 0) {
      $('#navblock ul.nav', target).clone().appendTo( $('#mobile-header', target) ).find('canvas, .rq').remove();
      $('#header .search', target).clone().wrap('<li>').parent().prependTo( $('#mobile-header ul.nav', target) );
    }

    $('#mobile-header ul.nav li:has(ul)', target).addClass('haschildren');
  }
}

theme.SidebarSection = new function(){
  this.onSectionLoad = function(target){
    /// Homepage layout
    theme.setHomepageLayout();
  }
}

theme.SidebarSharedSection = new function(){
  this.onSectionLoad = function(target){
    /// Sidebar recommended products
    $('.miniproductlist li .title', target).each(function(){
      //Set this to have a large width so the child span can find its natural width
      $(this).css('visibility', 'hidden').show().css('width', 600);
      $(this).width($(this).children().first().width() + 16);
      $(this).hide().css('visibility', '');
      //Now we have width, offset x
      var w = $(this).width();
      var contw = $(this).parent().width();
      $(this).css('left', (contw / 2 - w / 2) - 8);
    });
    //Init popup title fade in
    $('.miniproductlist', target).on('mouseenter mouseleave', 'li .imagecontainer', function(e){
      if($('#wrap').width() >= theme.mobileSnapWidth) {
        if(e.type == 'mouseenter') {
          $(this).prev().stop(true,true).fadeIn(200);
        } else {
          $(this).prev().stop(true,true).fadeOut(100);
        }
      }
    });
  }
  
  this.onSectionUnload = function(target){
    $('.miniproductlist', target).off('mouseenter mouseleave');
  }
}

theme.ProductTemplateSection = new function(){
  this.onSectionLoad = function(target){
    /// Variant options (dropdown or radio)
    $('#product-form select[name="id"], #product-form input[name="id"]', target).each(function(){
      theme.OptionManager.initProductOptions(this);
    });

	/// Product images
    $('.productimages .main a', target).fancybox({
      onStart: function(){ return $(window).width() >= theme.mobileSnapWidth; }
    });
  }
}

theme.BillboardSection = new function(){
  this.onSectionLoad = function(target){
    var target = target;
    $(target).imagesLoaded(function(){
      $(target).addClass('images-loaded');
    });
    
    $('.slideshow .slides', target).each(function(){
      $(this).slick({
        accessibility: true,
        prevArrow: $(this).closest('.slideshow').find('.previous'),
        nextArrow: $(this).closest('.slideshow').find('.next'),
        initialSlide: 0,
        fade: $(this).data('slide-fade') == 'fade' ? true : false,
        autoplay: true,
        autoplaySpeed: $(this).data('slide-speed')
      });
    });
  }
  
  this.onSectionUnload = function(target){
    $('.slick-slider', target).slick('unslick');
  }
  
  this.onBlockSelect = function(target){
    $(target).closest('.slick-slider')
      .slick('slickGoTo', $(target).data('slick-index'))
      .slick('slickPause');
  }
  
  this.onBlockDeselect = function(target){
    $(target).closest('.slick-slider').slick('slickPlay');
  }
}

theme.InstagramSection = new function(){
  this.onSectionLoad = function(target){
    $('.willstagram:not(.willstagram-placeholder)', target).each(function(){
      var user_id = $(this).data('user_id');
      var tag = $(this).data('tag');
      var access_token = $(this).data('access_token');
      var count = $(this).data('count') || 10;
      var $willstagram = $(this);
      var url = '';
      if(typeof user_id != 'undefined') {
        url = 'https://api.instagram.com/v1/users/' + user_id + '/media/recent?count='+count;
      } else if(typeof tag != 'undefined') {
        url = 'https://api.instagram.com/v1/tags/' + tag + '/media/recent?count='+count;
      }
      $.ajax({
        type: "GET",
        dataType: "jsonp",
        cache: false,
        url: url
        + (typeof access_token == 'undefined'? '' : ('&access_token='+access_token)),
        success: function(res) {
          if(typeof res.data != 'undefined') {
            var $itemContainer = $('<ul class="items">').appendTo($willstagram);
            var limit = Math.min(20, res.data.length);
            for(var i = 0; i < limit; i++) {
              var photo_url = res.data[i].images.low_resolution.url.replace('http:', '');
              var link = res.data[i].link;
              var caption = res.data[i].caption != null ? res.data[i].caption.text : '';
              $itemContainer.append($('<li />').append('<div class="item"><a target="_blank" href="'+link+'"><img src="'+photo_url+'" /></a><div class="desc">'+caption+'</div></div>'));
            }
          } else if(typeof res.meta !== 'undefined' && typeof res.meta.error_message !== 'undefined') {
            $willstagram.append('<div class="willstagram__error">'+res.meta.error_message+'</div>');
          }
      	}
      });
      if(typeof $(this).data('account') != 'undefined') {
        var splSel = $(this).data('account').split('|');
        var $account = $(this).closest(splSel[0]).find(splSel[1]);
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          url: 'https://api.instagram.com/v1/users/self/?access_token='+access_token,
          success: function(res) {
            if(typeof res.data != 'undefined') {
              $('<a>').html('@'+res.data.username).attr({
                href: 'https://www.instagram.com/'+res.data.username,
                target: '_blank'
              }).appendTo($account);
            }
          }
        });
      }
    });
  }
}

// Loading third party scripts
theme.scriptsLoaded = [];
theme.loadScriptOnce = function(src, callback) {
  if(theme.scriptsLoaded.indexOf(src) < 0) {
    theme.scriptsLoaded.push(src);
    var tag = document.createElement('script');
    tag.src = src;
    
    if(typeof callback == 'function') {
      if (tag.readyState) { // IE, incl. IE9
        tag.onreadystatechange = function() {
          if (tag.readyState == "loaded" || tag.readyState == "complete") {
            tag.onreadystatechange = null;
            callback();
          }
        };
      } else {
        tag.onload = function() { // Other browsers
          callback();
        };
      }
    }
    
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return true;
  } else {
    if(typeof callback == 'function') {
      callback();
    }
    return false;
  }
}

// Manage videos
theme.VideoManager = new function(){
  var _ = this;
  
  // Youtube
  _.youtubeVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)'
  };
  
  _.youtubeApiReady = function() {
    _.youtubeVars.apiReady = true;
    _._loadYoutubeVideos();
  }
  
  _._loadYoutubeVideos = function(container) {
    if($(_.youtubeVars.toProcessSelector, container).length) {
      if(_.youtubeVars.apiReady) {
        // play those videos
        $(_.youtubeVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.youtubeVars.incrementor++;
          var containerId = 'theme-yt-video-'+_.youtubeVars.incrementor;
          var videoElement = $('<div>').attr('id', containerId).appendTo(this);
          var player = new YT.Player(containerId, {
            height: '390',
            width: '640',
            videoId: $(this).data('video-id'),
            playerVars: {
              iv_load_policy: 3,
              modestbranding: 1,
              autoplay: !!$(this).data('video-autoplay') ? 1 : 0,
              rel: 0
            },
            events: {
              onReady: _._onYoutubePlayerReady,
              onStateChange: _._onYoutubePlayerStateChange
            }
          });
          _.youtubeVars.videoData[player.h.id] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player
          };
        });
      } else {
        // load api
        theme.loadScriptOnce('https://www.youtube.com/iframe_api');
      }
    }
  }
  
  _._onYoutubePlayerReady = function(event) {
    event.target.setPlaybackQuality('hd1080');
  }
       
  _._onYoutubePlayerStateChange = function(event) {
  }
    
  _._getYoutubeVideoData = function(event) {
    return _.youtubeVars.videoData[event.target.h.id];
  }
  
  _._unloadYoutubeVideos = function(container) {
    for(var dataKey in _.youtubeVars.videoData) {
      var data = _.youtubeVars.videoData[dataKey];
      if($(container).find(data.container).length) {
        data.player.destroy();
        delete _.youtubeVars.videoData[dataKey];
        return;
      }
    }
  }
  
  // Vimeo
  _.vimeoVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)'
  };
  
  _.vimeoApiReady = function() {
    _.vimeoVars.apiReady = true;
    _._loadVimeoVideos();
  }
  
  _._loadVimeoVideos = function(container) {
    if($(_.vimeoVars.toProcessSelector, container).length) {
      if(_.vimeoVars.apiReady) {
        // play those videos
        $(_.vimeoVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.vimeoVars.incrementor++;
          var $this = $(this);
          var containerId = 'theme-vi-video-'+_.vimeoVars.incrementor;
          var videoElement = $('<div>').attr('id', containerId).appendTo(this);
          var autoplay = !!$(this).data('video-autoplay');
          var player = new Vimeo.Player(containerId, {
            id: $(this).data('video-id'),
            width: 640,
            loop: false,
            autoplay: autoplay
          });
          player.ready().then(function(){
            if(player.element && player.element.width && player.element.height) {
              var ratio = parseInt(player.element.height) / parseInt(player.element.width);
              $this.css('padding-bottom', (ratio*100) + '%');
            }
          });
          _.vimeoVars.videoData[containerId] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player,
            autoPlay: autoplay
          };
        });
      } else {
        // load api
        theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
          _.vimeoVars.apiReady = true;
          _._loadVimeoVideos();
        });
      }
    }
  }
  
  _._unloadVimeoVideos = function(container) {
    for(var dataKey in _.vimeoVars.videoData) {
      var data = _.vimeoVars.videoData[dataKey];
      if($(container).find(data.container).length) {
        data.player.unload();
        delete _.vimeoVars.videoData[dataKey];
        return;
      }
    }
  }
  
  // Compatibility with Sections
  this.onSectionLoad = function(container){
    _._loadYoutubeVideos(container);
    _._loadVimeoVideos(container);
  }
  
  this.onSectionUnload = function(container){
    _._unloadYoutubeVideos(container);
    _._unloadVimeoVideos(container);
  }
}

// Youtube API callback
function onYouTubeIframeAPIReady() {
  theme.VideoManager.youtubeApiReady();
}

// Manage option dropdowns
theme.OptionManager = new function(){
  var _ = this;

  _.selectors = {
    container: '#content',
    gallery: '.productimages',
    priceArea: '#price-field',
    submitButton: 'input[type=submit], button[type=submit]',
    multiOption: '.option-selectors'
  };
  
  _.strings = {
    priceNonExistent: "Unavailable",
    priceSoldOut: '[PRICE]',
    buttonDefault: "Add to cart",
    buttonNoStock: "Out of stock",
    buttonNoVariant: "Unavailable"
  };
  
  _._getString = function(key, variant){
    var string = _.strings[key];
    if(variant) {
      string = string.replace('[PRICE]', Shopify.formatMoney(variant.price, theme.money_format));
    }
    return string;
  }
  
  _.getProductData = function($form) {
    var data = theme.productData[$form.data('product-id')];
    if(typeof data == 'undefined') {
      console.log('Product data missing (id: '+$form.data('product-id')+')');
    }
    return data;
  }
  
  _.addVariantUrlToHistory = function(variant) {
    if(variant) {
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    }
  }
  
  _.updateSku = function(variant, $container){
    $container.find('.sku .sku__value').html( variant ? variant.sku : '' );
    $container.find('.sku').toggleClass('sku--no-sku', !variant || !variant.sku);
  }
  
  _.updateBarcode = function(variant, $container){
    $container.find('.barcode .barcode__value').html( variant ? variant.barcode : '' );
    $container.find('.barcode').toggleClass('barcode--no-barcode', !variant || !variant.barcode);
  }
  
  _.updateBackorder = function(variant, $container){
    var $backorder = $container.find('.backorder');
    if($backorder.length) {
      if (variant && variant.available) {
        if (variant.inventory_management && variant.inventory_quantity <= 0) {
          var productData = _.getProductData($backorder.closest('form'));
          $backorder.find('.selected-variant').html(productData.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - '+variant.title) );
          $backorder.show();
        } else {
          $backorder.hide();
        }
      } else {
        $backorder.hide();
      }
    }
  }
  
  _.updatePrice = function(variant, $container) {
    var $priceArea = $container.find(_.selectors.priceArea);
    $priceArea.removeClass('on-sale');
    
    if(variant && variant.available == true) {
      var $newPriceArea = $('<div>');
      if(variant.compare_at_price > variant.price) {
        $('<span class="was-price">').html(Shopify.formatMoney(variant.compare_at_price, theme.money_format)).appendTo($newPriceArea);
        $newPriceArea.append(' ');
        $priceArea.addClass('on-sale');
      }
      $('<span class="current-price">').html(Shopify.formatMoney(variant.price, theme.money_format)).appendTo($newPriceArea);
      $priceArea.html($newPriceArea.html());
    } else {
      if(variant) {
        $priceArea.html(_._getString('priceSoldOut', variant));
      } else {
        $priceArea.html(_._getString('priceNonExistent', variant));
      }
    }
  }
  
  _._updateButtonText = function($button, string, variant) {
    $button.each(function(){
      var newVal;
      newVal = _._getString('button' + string, variant);
      if(newVal !== false) {
        if($(this).is('input')) {
          $(this).val(newVal);
        } else {
          $(this).html(newVal);
        }
      }
    });
  }
  
  _.updateButtons = function(variant, $container) {
    var $button = $container.find(_.selectors.submitButton);
    
    if(variant && variant.available == true) {
      $button.removeAttr('disabled');
      _._updateButtonText($button, 'Default', variant);
    } else {
      $button.attr('disabled', 'disabled');
      if(variant) {
        _._updateButtonText($button, 'NoStock', variant);
      } else {
        _._updateButtonText($button, 'NoVariant', variant);
      }
    }
  }
  
  _.initProductOptions = function(originalSelect) {
    $(originalSelect).not('.theme-init').addClass('theme-init').each(function(){
      var $originalSelect = $(this);
      var productData = _.getProductData($originalSelect.closest('form'));
      
      // change state for original dropdown
      $originalSelect.on('change', function(e, variant){
        if($(this).is('input[type=radio]:not(:checked)')) {
          return; // handle radios - only update for checked
        }
        var variant = variant;
        if(!variant && variant !== false) {
          for(var i=0; i<productData.variants.length; i++) {
            if(productData.variants[i].id == $(this).val()) {
              variant = productData.variants[i];
            }
          }
        }
        var $container = $(this).closest(_.selectors.container);
        
        // update price
        _.updatePrice(variant, $container);
        
        // update buttons
        _.updateButtons(variant, $container);

        // variant images
        if (variant && variant.featured_image) {
          $container.find(_.selectors.gallery).trigger('variantImageSelected', variant);
        }

        // extra details
        _.updateBarcode(variant, $container);
        _.updateSku(variant, $container);
        _.updateBackorder(variant, $container);

        // variant urls
        var $form = $(this).closest('form');
        if($form.data('enable-history-state')) {
          _.addVariantUrlToHistory(variant);
        }

        // multi-currency
        if(typeof Currency != 'undefined' && typeof Currency.convertAll != 'undefined' && $('[name=currencies]').length) {
          Currency.convertAll(shopCurrency, $('[name=currencies]').first().val());
          $('.selected-currency').text(Currency.currentCurrency);
        }
      });

      // split-options wrapper
      $originalSelect.closest(_.selectors.container).find(_.selectors.multiOption).on('change', 'select', function(){
        var selectedOptions = [];
        $(this).closest(_.selectors.multiOption).find('select').each(function(){
          selectedOptions.push($(this).val());
        });
        // find variant
        var variant = false;
        for(var i=0; i<productData.variants.length; i++) {
          var v = productData.variants[i];
          var matchCount = 0;
          for(var j=0; j<selectedOptions.length; j++) {
            if(v.options[j] == selectedOptions[j]) {
              matchCount++;
            }
          }
          if(matchCount == selectedOptions.length) {
            variant = v;
            break;
          }
        }
        // trigger change
        if(variant) {
          $originalSelect.val(variant.id);
        }
        $originalSelect.trigger('change', variant);
      });
      
      // first-run
      $originalSelect.trigger('change');
    });
  }
};


var $social = undefined;
$(function($){
  
  /// Product page gallery
  $(document).on('variantImageSelected', '.productimages', function(e, data){
    $(this).find('.main a').attr('href', data.featured_image.src);
    $(this).find('.main img').attr('src', data.featured_image.src);
  });
  
  $(document).on('shopify:section:load', function(e){
    /// Resize any product blocks - most sections can contain them
    if($('.productlist, .miniproductlist', e.target).length) {
      $('.productlist, .miniproductlist', e.target).imagesLoaded(function(){
        $(window).trigger('forceproductblockheights');
      });
    }
    /// Product page sharing
    if($('.social.clearfix').length==1) {
      $('.social.clearfix').remove();
      $('#breadcrumbs').append($social);
    }
  }) // end of ready shopify:section:load
  .on('shopify:section:unload', function(e){
    if($('.social.clearfix').length==1) {
      $social = $('.social.clearfix').clone();
    }
  }); // end of ready shopify:section:unload

  
  //jQuery extensions
  $.support.placeholder = (function(){
    var i = document.createElement('input');
    return 'placeholder' in i;
  })();
  
  //Normalise heights for product thumb details
  $.fn.normaliseHeights = function(options) {
    //options = { numPerRow:4, itemClass:'.product', textRegionClasses:'.title, .desc', affectOnlyDirectlyChildren:false }
    var settings = { affectOnlyDirectlyChildren: false, updatedElement: false};
    $.extend(settings, options);
    
    $(this).each(function(){
      var itemsToAssess = settings.textRegionClasses.split(',');
      var $outerthis = $(this);
      $.each(itemsToAssess, function(index, value){
        if(settings.affectOnlyDirectlyChildren) {
          var $allChunks = $outerthis.find(settings.itemClass + ' > ' + value);
        } else {
          var $allChunks = $outerthis.find(settings.itemClass + ' ' + value);
        }
        for (i = 0; i < $allChunks.length; i += settings.numPerRow) {
          var end = Math.min(i + settings.numPerRow, $allChunks.length);
          var tallest = 0;
          var $sliced = $allChunks.slice(i, end);
          var doHeights = settings.updatedElement === false;
          if(settings.updatedElement !== false) {
            for(var j=0; j<$sliced.length; j++) {
              if($sliced[j] == settings.updatedElement) {
                doHeights = true;
                break;
              }
            }
          }
          if(doHeights) {
            $sliced.each(function(){
              var thisHeight = $(this).css({ height:'', lineHeight:'' }).height();
              if(thisHeight > tallest) {
                tallest = thisHeight;
              }
            });
            //If just one per row - auto height
            if(settings.numPerRow > 1) {
              $sliced.css('height', tallest);
            }
          }
        }
      });
    });
    return $(this);
  };
  
  //Mobile nav
  $(document).on('click', '#toggle-mobile-menu, .toggle-mobile-menu', function(e){
    $('body').toggleClass('revealnav');
    return false;
  });
  
  // Assess product layout and alignment
  $(window).on('load resize productblockheights forceproductblockheights', function(e) {
    if(e.type == 'forceproductblockheights' || e.type == 'load') {
      $('#wrap').data('prevwidth', null);
    }
    //Do things when theme snaps - and on DOM ready
    var $wrapcont = $('#wrap');
    var contWidth = $wrapcont.width();
    if(typeof($wrapcont.data('prevwidth')) == 'undefined'
       || $wrapcont.data('prevwidth') != contWidth) {
      //Do this when CSS framework 'snaps'

      $('.productlist').each(function(){
		var productsPerRowRightNow = $(window).width() >= theme.mobileSnapWidth ? ($('#content.hasaside').length > 0 ? 3 : 4) : 1;
        if(productsPerRowRightNow == 4 && $(this).closest('.col-3-right').length) {
          productsPerRowRightNow = 3;
        }
        $(this).normaliseHeights({
          numPerRow: productsPerRowRightNow,
          itemClass: '.product',
          textRegionClasses: '.imagecontainer, .title'
        }).find('.imagecontainer').each(function(){
          $(this).css('line-height', ($(this).height()-5)+'px');
        });
      });
      $('.miniproductlist').normaliseHeights({
        numPerRow: $(window).width() >= theme.mobileSnapWidth ? 4 : 1,
        itemClass: 'li',
        textRegionClasses: '.imagecontainer'
      }).find('.imagecontainer').each(function(){
        $(this).css('line-height', $(this).height()+'px');
      });
    }
    $wrapcont.data('prevwidth', contWidth);
  });
  
  $('.productlist, .miniproductlist').imagesLoaded(function(){
    $(window).trigger('forceproductblockheights');
  });
  
  
  //Nav
  $(document).on('mouseenter', '#header #navblock ul.nav li', function() {
    var $ul = $(this).children('ul, .notch').stop(true, true).fadeIn(200).filter('ul');
    if($ul.length && $ul.offset().left + $ul.outerWidth() > $(window).width()) {
      $ul.addClass('show-to-left');
    }
  }).on('mouseleave', '#header #navblock ul.nav li', function() {
    $(this).children('ul, .notch').stop(true, true).fadeOut(200, function(){
      $(this).filter('ul').removeClass('show-to-left');
    });
  });

  //JS fallback for placeholder text
  if(!$.support.placeholder) {
    $('input, textarea').each(function(){
      var plhld = $(this).attr('placeholder');
      if(typeof(plhld) == 'undefined') {
        $(this).addClass('jsdeftext').addClass('masked').data('deftext', plhld).focus(function(){
          if($(this).val() == $(this).data('deftext')) {
            $(this).val('').removeClass('masked');
          }
        }).blur(function(){
          if($(this).val() == '') {
            $(this).val($(this).data('deftext')).addClass('masked');
          }
        }).trigger('blur');
      }
    });
    //On submit form, do not submit any placeholder text
    $('form').on('click', 'input[type=submit], button', function(){
      $(this).closest('form').find('.jsdeftext').each(function(){
        if($(this).val() == $(this).data('deftext')) {
          $(this).val('');
        }
      });
    });
  }

  //Mobile nav
  $(document).on('click', '#mobile-header ul.nav li:has(ul) > a', function(){
    if($(this).parent().toggleClass('reveal').hasClass('reveal')) {
      $(this).siblings('ul').slideDown();
    } else {
      $(this).siblings('ul').slideUp();
    }
    return false;
  });

  
  /// Product thumbnails
  $(document).on('click', '#content .productimages .thumbs a', function(){
    var $atag = $(this);
    var $maincont = $('#content .productimages .main');
    var $mainconta = $maincont.find('a');
    if($mainconta.find('.mainimg').attr('src') != $atag.data('hrefgrande')) {
      $maincont.height($maincont.height());
      $maincont.addClass('loading');
      $mainconta.find('.mainimg').removeClass('mainimg').fadeOut(200, function(){ 
        $(this).remove();
        $('<img class="mainimg">').bind('load', function(){
          $imgOnPage = $(this).appendTo($mainconta);
          $maincont.stop(true,true).animate({'height': $imgOnPage.height()}, 200);
          $imgOnPage.css({'display':'none', 'visibility':'visible'}).fadeIn(200, function(){
            $maincont.removeClass('loading');
          });
          $mainconta.attr('href', $atag.attr('href'));
        }).attr('src', $atag.data('hrefgrande')).css('visibility', 'hidden');
      });

      return false;
    }
    return false;
  });
  
  
  
  //AJAX add-to-cart
  $(document).on('submit', 'form[action*="/cart/add"]', function(e) {
    //Prevent normal submit
    e.preventDefault();
    //Disable the add button until this process is over
    $(e.target).find('.addbutton').attr('disabled', true).addClass('disabled');
    //Add the item to your cart
    Shopify.addItemFromForm($(this).attr('id'));
  });

  //Function to display a popup message after adding to cart
  $.extend({
    shopAddPopup : function(options) {
      var settings = $.extend({
        title: '',
        message: '',
        $positionElement: null
      }, options);
      var $popup = $('<div>').html(settings.message).addClass('addToCartPopup').hide();
      var $otherPopups = $('.addToCartPopup');
      if($otherPopups.length > 0) {
        var toppest = 0;
        for(var i=0; i<$otherPopups.length; i++) {
          var thisTop = parseInt($($otherPopups[i]).css('top').replace("px", ""));
          if(thisTop > toppest) {
            toppest = thisTop;
          }
        }
        $popup.css('top', toppest + 55);
      }
      $popup.appendTo('body').fadeIn(500).each(function(){
        $(this).css('margin-left', -$(this).outerWidth()/2);
      }).delay(3000).fadeOut(1000, function(){ $(this).remove(); });
    }
  });
  //Override
  Shopify.onItemAdded = function(line_item) {
    //Make button usable again
    var $addedButton = $('form .addbutton.disabled');
    $addedButton.attr('disabled', false).removeClass('disabled');
    //Adding to cart successful, update cart
    Shopify.getCart();
    //Show friendly popup
    $.shopAddPopup({title: '', message: line_item.title + ' ' + "added to cart", positionElement: $addedButton});
  }

  //Override
  Shopify.onError = function(XMLHttpRequest, textStatus) {
    //Fetch button that triggered this and make it usable again
    var $addedButton = $('form .addbutton.disabled');
    $addedButton.attr('disabled', false).removeClass('disabled');
    //Display error message
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      $.shopAddPopup({title: data.message, message: data.description, positionElement: $addedButton});
    } else {
      $.shopAddPopup({message: Shopify.fullMessagesFromErrors(data).join('; '), positionElement: $addedButton});
    }  
  };

  //Override
  Shopify.onCartUpdate = function(cart) {
    $('.cartitems .count').html(cart.item_count);
    //Replace the cart summary in sidebar
    if($('#aside .cartsummary').length > 0) {
      //Fetch current page again with json
      $.get(window.location.toString(), function(data){
        $('#aside').replaceWith($($.parseHTML('<div>'+data+'</div>')).find('#aside'));
      });
    }
  }
  
  
  /// Register all sections
  theme.Sections.init();
  theme.Sections.register('header', theme.HeaderSection);
  theme.Sections.register('sidebar', theme.SidebarSection);
  theme.Sections.register('sidebar-shared', theme.SidebarSharedSection);
  theme.Sections.register('billboard', theme.BillboardSection);
  theme.Sections.register('instagram', theme.InstagramSection);
  theme.Sections.register('video', theme.VideoManager);
  theme.Sections.register('product-template', theme.ProductTemplateSection);
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}